import {Container, ThemeProvider} from '@mui/material';
import defaultTheme from '../components/Themes/defaultTheme';
import "../assets/css/main.css"
import { Button, List, ListItem, Typography } from '@mui/material/node';

export const Tos = () => {
  return (
    <>
    <ThemeProvider theme={defaultTheme}>
      <Container disableGutters maxWidth="lg" component="main" sx={{ pt: 5, pb: 6, px: 3 }}>
        <Button onClick={() => window.location.href = 'https://nodecanvas.app'}>Back</Button>
        <Typography variant="h2" sx={{ pt: 2, pb: 2 }}>
        Terms and Conditions
        </Typography>
        <Typography variant="body1">
Last updated: January 2026
</Typography>
<Typography variant="h4" sx={{ pt: 2, pb: 2 }}>1. Introduction</Typography>
<Typography variant="body1">
These Terms and Conditions ("Terms") govern your access to and use of the NodeCanvas SaaS application available at https://nodecanvas.app (the "Service"). The Service is operated by the provider located in the Slovak Republic ("we", "us", "our").
<br/>
By accessing or using the Service, you confirm that you have read, understood, and agree to be bound by these Terms. If you do not agree, you must not use the Service.
</Typography>
<Typography variant="h4" sx={{ pt: 2, pb: 2 }}>2. Eligibility and Consumer Notice</Typography>
<Typography variant="body1">
If you are a consumer within the meaning of EU consumer protection law, nothing in these Terms limits or excludes your mandatory statutory rights.
<br/><br/>
If you are using the Service on behalf of a business or other legal entity, you represent that you have the authority to bind that entity to these Terms.
</Typography>
<Typography variant="h4" sx={{ pt: 2, pb: 2 }}>3. Description of the Service</Typography>
<Typography variant="body1">
NodeCanvas is a software-as-a-service platform that allows users to create, manage, and share visual diagrams, structures, and other user-generated content. The Service is provided "as is" and "as available".
<br/><br/>
We reserve the right to modify, suspend, or discontinue any part of the Service at any time.
</Typography>
<Typography variant="h4" sx={{ pt: 2, pb: 2 }}>4. License and Access</Typography>
<Typography variant="body1">
Subject to these Terms, we grant you a limited, non-exclusive, non-transferable, and revocable license to access and use the Service for its intended purpose.
<br/><br/>
We reserve the right to suspend or terminate your access to the Service at any time, with or without notice, in particular if:
<br/>
<List>
  <ListItem>• you violate these Terms,</ListItem>
  <ListItem>• required by law or a public authority,</ListItem>
  <ListItem>• necessary to protect the security, integrity, or availability of the Service.</ListItem>
</List>

Termination does not give rise to any right to compensation, except where mandatory law requires otherwise.
</Typography>
<Typography variant="h4" sx={{ pt: 2, pb: 2 }}>5. User Content</Typography>
<Typography variant="body1">
You are solely responsible for all data, content, and materials you upload, create, or share through the Service ("User Content").
<br/><br/>
We do not monitor or control User Content and accept no responsibility for it. You represent and warrant that:
<br/>
<List>
  <ListItem>• You have all necessary rights to your User Content,</ListItem>
  <ListItem>• Your User Content does not violate any applicable law or third-party rights.</ListItem>
</List>

We reserve the right (but not the obligation) to remove or restrict access to User Content at our discretion.
</Typography>
<Typography variant="h4" sx={{ pt: 2, pb: 2 }}>6. Disclaimer of Warranties</Typography>
<Typography variant="body1">
To the maximum extent permitted by applicable EU and Slovak law:

<List>
  <ListItem>• The Service is provided without warranties of any kind, whether express or implied.</ListItem>
  <ListItem>• We do not warrant that the Service will be uninterrupted, secure, error-free, or fit for any particular purpose.</ListItem>
  <ListItem>• We do not warrant that any data will be preserved without loss or corruption.</ListItem>
</List>

This disclaimer does not affect statutory warranties that cannot be excluded under applicable law.
</Typography>
<Typography variant="h4" sx={{ pt: 2, pb: 2 }}>7. Limitation of Liability</Typography>
<Typography variant="body1">
To the maximum extent permitted by applicable law:<br/>
<List>
<ListItem>- We shall not be liable for any indirect, incidental, consequential, special, or punitive damages, including but not limited to loss of profits, loss of data, business interruption, or reputational harm.</ListItem>
<ListItem>- We shall not be liable for damages resulting from:</ListItem>

<List component="div" disablePadding>
  <ListItem sx={{ pl: 4 }}>• use or inability to use the Service,</ListItem>
  <ListItem sx={{ pl: 4 }}>• user-generated content,</ListItem>
  <ListItem sx={{ pl: 4 }}>• unauthorized access to or alteration of your data,</ListItem>
  <ListItem sx={{ pl: 4 }}>• events beyond our reasonable control.</ListItem>
</List>
</List>

Our total aggregate liability for any claims arising out of or related to the Service shall not exceed the amount actually paid by you for the Service in the twelve (12) months preceding the event giving rise to the claim.
<br/><br/>
Nothing in these Terms limits or excludes liability for:
<List>
<ListItem>- death or personal injury caused by gross negligence or intent,</ListItem>
<ListItem>- fraud or fraudulent misrepresentation,</ListItem>
<ListItem>- any liability that cannot be limited under EU or Slovak law.</ListItem>
</List>
</Typography>
<Typography variant="h4" sx={{ pt: 2, pb: 2 }}>8. Data Protection</Typography>
<Typography variant="body1">
Personal data is processed in accordance with our Privacy Policy and applicable data protection laws, including Regulation (EU) 2016/679 (GDPR).
</Typography>
<Typography variant="h4" sx={{ pt: 2, pb: 2 }}>9. Indemnification</Typography>
<Typography variant="body1">
You agree to indemnify and hold us harmless from any claims, damages, losses, or expenses arising out of:
<br/>
<List>
<ListItem>• your use of the Service,</ListItem>
<ListItem>• your User Content,</ListItem>
<ListItem>• your violation of these Terms or applicable law.</ListItem>
</List>
</Typography>
<Typography variant="h4" sx={{ pt: 2, pb: 2 }}>10. Force Majeure</Typography>
<Typography variant="body1">
We shall not be liable for failure or delay in performance caused by events beyond our reasonable control, including but not limited to natural disasters, power failures, internet outages, strikes, or governmental actions.
</Typography>
<Typography variant="h4" sx={{ pt: 2, pb: 2 }}>11. Governing Law and Jurisdiction</Typography>
<Typography variant="body1">
These Terms shall be governed by and construed in accordance with the laws of the Slovak Republic.
<br/>
If you are a consumer residing in the European Union, you may also benefit from mandatory consumer protection rules of your country of residence.
<br/>
Any disputes shall be subject to the jurisdiction of the competent courts of the Slovak Republic, unless mandatory law provides otherwise.
</Typography>
<Typography variant="h4" sx={{ pt: 2, pb: 2 }}>12. Final Provisions</Typography>
<Typography variant="body1">
If any provision of these Terms is held to be invalid or unenforceable, the remaining provisions shall remain in full force and effect.
<br/>
We may update these Terms from time to time. Continued use of the Service after changes become effective constitutes acceptance of the updated Terms.
</Typography>
      </Container>
      </ThemeProvider>
    </>
  );
};